module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 13 Farma Pasa - KK (gost. Eli Maca).24812e61.mp3";